// Conector do banco REAL do site (Supabase wwwzcd — o mesmo do tocadaoncamodas.com.br)
// Chave anônima pública (client-side, protegida por RLS). Leitura segura.
import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://wwwzcdmiusaulwlfrlfu.supabase.co";
const SUPABASE_ANON = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Ind3d3pjZG1pdXNhdWx3bGZybGZ1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODAyMDE5NzIsImV4cCI6MjA5NTc3Nzk3Mn0.yIz25ZQVGk9qyYZiNk2fU9uTC4mEqctNXFh5_qV3exg";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON, {
  auth: { persistSession: false },
});
